var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibility || _vm.fadeIn)?_c('div',{class:("anx-toast-container anx-toast-" + _vm.horizontalAlign)},[_c('div',{class:[
      {
        'anx-toast': true,
        show: _vm.visibility,
        'fade-in': _vm.fadeIn,
        'fade-out': _vm.fadeOut
      },
      ("anx-toast-" + _vm.type)
    ],style:(_vm.cssProps),on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }